// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  campaignId: __t.u64().primaryKey().name("campaign_id"),
  cyc: __t.u64(),
  fortKey: __t.string().name("fort_key"),
  targetSystem: __t.string().name("target_system"),
  state: __t.string(),
  openedAt: __t.timestamp().name("opened_at"),
  endsAt: __t.timestamp().name("ends_at"),
  winner: __t.string(),
  retreatSide: __t.i32().name("retreat_side"),
  rounds: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
